(function () {
  'use strict';

  var section = document.querySelector('.house-about');
  if (!section) return;

  var title = section.querySelector('.house-about__header');
  var floatEl = section.querySelector('.house-about__float');
  var tiles = section.querySelector('.house-about__tiles');
  var tileItems = tiles ? Array.from(tiles.querySelectorAll('.house-about__tile')) : [];
  var stepSlot = section.querySelector('.house-about__step-slot');
  var stepStrip = section.querySelector('.house-about__step-strip');
  var stepTotal = section.querySelector('.house-about__step-total');
  var stepsEl = section.querySelector('.house-about__steps');

  var copies = {};
  var frameKeys = [];
  Array.from(section.querySelectorAll('[data-copy]')).forEach(function (frame) {
    var key = frame.getAttribute('data-copy');
    copies[key] = frame;
    frameKeys.push(key);
  });

  var peakWordItems = copies.peak
    ? Array.from(copies.peak.querySelectorAll('[data-cycle-item]'))
    : [];

  var current = 0;
  var displayedStepIndex = 0;
  var stepTween = null;
  var maxIndex = 6;
  var transitionToken = 0;
  var copyShown = null;
  var protagonistsHeldForMask = false;
  var protagonistsHold = null;
  var staggerCalls = [];
  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  /* Raw progress at which the second block is released. The frame is on
     screen across raw 1.5 -> 2.0 (the index rounds to 2 from 1.5, and
     protagonistsMaskOpen holds it until 2), so this sits a little past the
     middle of that run. */
  var PROTAGONISTS_STAGE2_AT = 1.8;

  /* Seconds between one line landing and the next starting. The house default
     for grouped copy is 0.08, which on single-line paragraphs reads as all
     three arriving together; each line here is its own beat. A line's own
     reveal runs 1s, so they still overlap rather than queueing. */
  var PROTAGONISTS_LINE_STAGGER = 0.35;
  /* Dither mask 2→3 starts interpolating once raw progress leaves step 2.
     The rounded index still reads as 2 until 2.5, so the copy would otherwise
     stay up (and lockScroll) while the circle is mid-close. */
  var PROTAGONISTS_MASK_STEP = 2;

  /* "Our" is static; violence / beauty / contradictions cycle after it.

     This used to scrub against raw scroll progress, which meant scrolling
     quickly through step 4→5 skipped straight past all three. It is now a
     looping timeline on its own clock, started once the frame is on screen
     and the top paragraph has landed, so the reader always sees the full
     cycle regardless of how fast they arrived.

     Scroll still controls the master opacity, so the line clears before the
     tile gallery at step 6 exactly as before. */
  var PEAK_WORDS_HIDE_FROM = 5;
  var PEAK_WORDS_HIDE_TO = 5.5;
  var PEAK_TYPE_STEP = 0.045;  // seconds per character typed
  var PEAK_ERASE_STEP = 0.025; // backspace runs quicker than typing
  var PEAK_DOT_STEP = 0.18;    // seconds per dot as the ellipsis ticks over
  var PEAK_DOT_HOLD = 0.32;    // pause on a complete "..."
  var PEAK_DOT_CYCLES = 2;     // times the ellipsis runs before backspacing
  var peakTopReady = false;
  var peakTopTimer = null;
  var peakLoop = null;
  var peakBottom = copies.peak
    ? copies.peak.querySelector('.house-about__copy--peak-bottom')
    : null;


  function lenis() {
    return window.lenis;
  }

  var scrollLocked = false;
  var lockWatchdog = null;
  var LOCK_WATCHDOG = 4;

  function preventScrollEvent(event) {
    event.preventDefault();
  }

  function armLockWatchdog(seconds) {
    if (lockWatchdog) lockWatchdog.kill();
    lockWatchdog = gsap.delayedCall(seconds || LOCK_WATCHDOG, function () {
      lockWatchdog = null;
      unlockScroll();
    });
  }

  /* Freezes scrolling so a reader can't skip past the protagonists reveal
     mid-sequence. Uses Lenis' own stop/start where available; the
     wheel/touchmove guards are a safety net for the (unused today) plain
     native-scroll fallback path. A watchdog always releases the lock so a
     killed hold timer cannot strand the reader — especially on mobile,
     where a flick can supersede the reveal before its unlock runs. */
  function lockScroll(maxHold) {
    if (!scrollLocked) {
      scrollLocked = true;
      var instance = lenis();
      if (instance) instance.stop();
      window.addEventListener('wheel', preventScrollEvent, { passive: false });
      window.addEventListener('touchmove', preventScrollEvent, { passive: false });
    }
    armLockWatchdog(maxHold);
  }

  function unlockScroll() {
    if (lockWatchdog) {
      lockWatchdog.kill();
      lockWatchdog = null;
    }
    if (!scrollLocked) return;
    scrollLocked = false;
    var instance = lenis();
    if (instance) instance.start();
    window.removeEventListener('wheel', preventScrollEvent, { passive: false });
    window.removeEventListener('touchmove', preventScrollEvent, { passive: false });
  }

  function scrollY() {
    return lenis() ? lenis().scroll : window.scrollY;
  }

  /* Scroll distance per step, in vh. At the original 100 a step was one
     viewport, and the protagonists copy - which only holds while the dither
     mask is fully open, raw 1.5 -> 2.0 - got half of that. Half a viewport was
     short enough that a single flick carried the reader past both halves of
     the copy before either had landed. */
  var STEP_TRACK_VH = 150;

  function setTrackHeight() {
    section.style.height = (maxIndex + 1) * STEP_TRACK_VH + 'vh';
  }

  function sectionTop() {
    return section.getBoundingClientRect().top + scrollY();
  }

  function travel() {
    return Math.max(1, section.offsetHeight - window.innerHeight);
  }

  function progressFromScroll() {
    return gsap.utils.clamp(0, 1, (scrollY() - sectionTop()) / travel());
  }

  function scrollTopForProgress(progress) {
    return sectionTop() + progress * travel();
  }

  function rawFromScroll() {
    return progressFromScroll() * maxIndex;
  }

  function indexFromScroll() {
    var raw = rawFromScroll();
    if (raw > maxIndex - 1) return maxIndex;
    return Math.round(raw);
  }

  function protagonistsMaskOpen() {
    return rawFromScroll() <= PROTAGONISTS_MASK_STEP;
  }

  function isInPinnedRange() {
    var rect = section.getBoundingClientRect();
    return rect.top <= 1 && rect.bottom >= window.innerHeight - 1;
  }

  var TOTAL_STEPS = maxIndex + 1;

  function copyKey(index) {
    if (index <= 0 || index >= maxIndex || !frameKeys.length) return null;
    var slot = index - 1;
    var frameIndex = Math.min(frameKeys.length - 1, slot);
    return frameKeys[frameIndex];
  }

  function copyParts(frame) {
    return frame ? Array.from(frame.querySelectorAll('[data-animate="body"]')) : [];
  }

  function getDigitHeight() {
    if (!stepStrip || !stepStrip.firstElementChild) return 0;
    return stepStrip.firstElementChild.offsetHeight;
  }

  function updateStepLabel(index) {
    if (stepsEl) {
      stepsEl.setAttribute(
        'aria-label',
        'Step ' + (index + 1) + ' of ' + TOTAL_STEPS
      );
    }
  }

  function syncSlotMetrics() {
    var height = getDigitHeight();
    if (stepSlot && height) {
      stepSlot.style.height = height + 'px';
    }
    return height;
  }

  function setStepInstant(index) {
    if (!stepStrip) return;
    var height = syncSlotMetrics();
    gsap.set(stepStrip, { y: -index * height });
    displayedStepIndex = index;
    updateStepLabel(index);
  }

  function animateStep(index) {
    if (index === displayedStepIndex || !stepStrip) {
      return gsap.timeline();
    }

    if (stepTween) {
      stepTween.kill();
      stepTween = null;
    }

    var height = getDigitHeight();
    var targetY = -index * height;

    if (prefersReducedMotion || !height) {
      setStepInstant(index);
      return gsap.timeline();
    }

    stepTween = gsap
      .timeline()
      .to(stepStrip, {
        y: targetY,
        duration: 0.8,
        ease: 'power2.inOut',
      })
      .add(function () {
        displayedStepIndex = index;
        updateStepLabel(index);
        stepTween = null;
      });

    return stepTween;
  }

  function initSteps() {
    if (stepTotal) {
      stepTotal.textContent = '-' + TOTAL_STEPS;
    }
    setStepInstant(0);
  }

  function syncStepChange(index) {
    animateStep(index);
  }

  function copyMarks(frame) {
    return frame ? Array.from(frame.querySelectorAll('[data-animation]')) : [];
  }

  function partDelay(el, index) {
    var raw = parseFloat(el.getAttribute('data-delay'));
    return isNaN(raw) ? index * 0.08 : raw / 1000;
  }

  function resetMarks(frame) {
    if (frame._markTimers) {
      frame._markTimers.forEach(clearTimeout);
    }
    frame._markTimers = [];
    clearStaggerCalls();
    if (frame._sequentialTl) {
      var stillPlaying = frame._sequentialTl.isActive();
      frame._sequentialTl.kill();
      frame._sequentialTl = null;
      if (stillPlaying) unlockScroll();
    }
    copyMarks(frame).forEach(function (mark) {
      mark.classList.remove('in-view');
    });
  }

  function prepareCopies() {
    Object.keys(copies).forEach(function (key) {
      var frame = copies[key];
      gsap.set(frame, { autoAlpha: 0 });
      resetMarks(frame);
      copyParts(frame).forEach(function (part) {
        if (typeof window.animateBodyText === 'function' && !prefersReducedMotion) {
          window.animateBodyText(part, {
            useScrollTrigger: false,
            autoPlay: false,
          });
        }
      });
    });
  }

  /* How long a paragraph's own line-reveal animation takes, so the next
     step in a sequence can wait for it instead of guessing a fixed value. */
  function bodyDuration(part) {
    var tl = part && part._bodyLineTimeline;
    var d = tl && tl.duration();
    return d ? d : 1.1;
  }

  function stageParts(frame, stage) {
    return Array.prototype.slice.call(frame.querySelectorAll(
      '[data-animate="body"][data-reveal-stage="' + stage + '"]'));
  }

  function clearStaggerCalls() {
    staggerCalls.forEach(function (call) { call.kill(); });
    staggerCalls = [];
  }

  /* playBodyText passes its delay to tl.delay(), which does nothing here:
     these are root-level timelines that have already started, so a delay set
     after pause(0) does not reposition them and play() runs them at once -
     every line arrived together. Schedule the plays instead. */
  function playParts(parts, stagger) {
    var step = typeof stagger === 'number' ? stagger : 0.08;
    clearStaggerCalls();
    parts.forEach(function (part, index) {
      if (typeof window.playBodyText !== 'function') return;
      if (!index) {
        window.playBodyText(part, 0);
        return;
      }
      staggerCalls.push(gsap.delayedCall(index * step, function () {
        window.playBodyText(part, 0);
      }));
    });
  }

  function clearProtagonistsHold() {
    if (!protagonistsHold) return;
    protagonistsHold.kill();
    protagonistsHold = null;
  }

  /* setFrame queues showCopy behind the outgoing copy's hide, which reverses
     its line timelines and can run for a second. Locking only when the copy
     finally plays left that whole second open, and a hard flick crosses the
     frame's 884px inside it - raw passes 2, the mask starts closing, and the
     copy is held for a mask that never reopens on the way down. So take the
     hold the instant setFrame commits to this frame. The delayedCall is a
     safety release only: if the transition is superseded and the copy never
     plays, the reader must not be stranded with scroll disabled.
     holdWhileRevealing replaces it with the real release. */
  function holdProtagonistsEntry() {
    clearProtagonistsHold();
    lockScroll(2.5);
    protagonistsHold = gsap.delayedCall(2.5, function () {
      protagonistsHold = null;
      unlockScroll();
    });
  }

  /* The frame held scroll while it played before it was split in two, and
     without that a quick flick carried the reader past copy that had not
     landed - or past the frame entirely, since nothing here snaps to a step.
     Each stage takes the same hold and releases it as its last line settles,
     so the scroll between the two stages is still the reader's own. */
  function holdWhileRevealing(parts) {
    if (!parts.length) return;
    var last = parts[parts.length - 1];
    var wait = (parts.length - 1) * PROTAGONISTS_LINE_STAGGER + bodyDuration(last);
    clearProtagonistsHold();
    lockScroll(wait + 0.75);
    protagonistsHold = gsap.delayedCall(wait, function () {
      protagonistsHold = null;
      unlockScroll();
    });
  }

  /* The frame no longer plays as one locked sequence. The opening line lands
     when the frame arrives; the rest is held back and released once the
     reader has scrolled on through the step, so the second block reveals as
     they go rather than everything arriving at once. */
  function showProtagonistsStaged(frame) {
    frame._stage2Played = false;

    /* Held at the start of their own timelines rather than left wherever the
       last pass finished, so nothing of the second block is on screen yet. */
    stageParts(frame, 2).forEach(function (part) {
      if (part._bodyLineTimeline) part._bodyLineTimeline.pause(0);
    });

    var first = stageParts(frame, 1);
    playParts(first, PROTAGONISTS_LINE_STAGGER);
    holdWhileRevealing(first);
    syncProtagonistsStage();
  }

  function syncProtagonistsStage() {
    var frame = copies.protagonists;
    if (!frame || copyShown !== 'protagonists' || frame._stage2Played) return;
    if (rawFromScroll() < PROTAGONISTS_STAGE2_AT) return;

    frame._stage2Played = true;
    var second = stageParts(frame, 2);
    playParts(second, PROTAGONISTS_LINE_STAGGER);
    holdWhileRevealing(second);
  }

  /* One phrase at a time: hold, fade out, empty gap, fade in the next.
     The first phrase starts already held (it appears when the top para
     finishes), and the last stays held until the 5→5.5 hide. */
  /* Splits a phrase into per-character spans once. Every character stays in
     the layout from the start and is merely hidden, so revealing them types
     the line out without the box resizing — which is what would otherwise
     drag a centred line sideways as it grows. */
  function splitPeakChars(el) {
    if (el._peakChars) return el._peakChars;

    var text = el.textContent;
    var frag = document.createDocumentFragment();
    var chars = [];
    var i;

    // Trailing dots are tagged so the ellipsis can tick over on its own once
    // the word itself has finished typing.
    var trailing = /\.+$/.exec(text);
    var dotStart = trailing ? text.length - trailing[0].length : text.length;

    for (i = 0; i < text.length; i++) {
      var c = document.createElement('span');
      c.setAttribute('data-cycle-char', '');
      if (i >= dotStart) c.setAttribute('data-cycle-dot', '');
      c.textContent = text.charAt(i);
      frag.appendChild(c);
      chars.push(c);
    }

    el.textContent = '';
    el.appendChild(frag);
    el._peakChars = chars;
    return chars;
  }

  /* Type in, hold, backspace out, next phrase. Zero-duration steps with a
     stagger give a hard per-character on/off — a fade would read as the text
     resolving rather than being typed. */
  function buildPeakLoop() {
    if (peakLoop) {
      peakLoop.kill();
      peakLoop = null;
    }
    if (!peakWordItems.length) return null;

    if (prefersReducedMotion) {
      // No motion: show the first phrase complete and leave it.
      peakWordItems.forEach(function (item, i) {
        var chars = splitPeakChars(item);
        gsap.set(item, {
          opacity: i === 0 ? 1 : 0,
          visibility: i === 0 ? 'visible' : 'hidden',
        });
        gsap.set(chars, { opacity: i === 0 ? 1 : 0 });
      });
      return null;
    }

    var tl = gsap.timeline({ repeat: -1 });

    peakWordItems.forEach(function (item) {
      var chars = splitPeakChars(item);

      var dots = chars.filter(function (c) { return c.hasAttribute('data-cycle-dot'); });
      var word = chars.filter(function (c) { return !c.hasAttribute('data-cycle-dot'); });
      var k;

      tl.set(item, { visibility: 'visible', opacity: 1 })
        .set(chars, { opacity: 0 })
        // type the word itself
        .to(word, {
          opacity: 1,
          duration: 0,
          ease: 'none',
          stagger: PEAK_TYPE_STEP,
        });

      // then the ellipsis ticks over in place, . .. ...
      for (k = 0; k < PEAK_DOT_CYCLES; k++) {
        tl.set(dots, { opacity: 0 })
          .to(dots, {
            opacity: 1,
            duration: 0,
            ease: 'none',
            stagger: PEAK_DOT_STEP,
          })
          .to({}, { duration: PEAK_DOT_HOLD });
      }

      // backspace the whole line
      tl.to(chars, {
        opacity: 0,
        duration: 0,
        ease: 'none',
        stagger: { each: PEAK_ERASE_STEP, from: 'end' },
      })
        .set(item, { visibility: 'hidden', opacity: 0 });
    });

    return tl;
  }

  function stopPeakLoop() {
    if (peakLoop) {
      peakLoop.kill();
      peakLoop = null;
    }
    peakWordItems.forEach(function (item) {
      gsap.set(item, { opacity: 0, visibility: 'hidden' });
      if (item._peakChars) gsap.set(item._peakChars, { opacity: 0 });
    });
  }

  function armPeakWords(frame) {
    peakTopReady = false;
    if (peakTopTimer) {
      peakTopTimer.kill();
      peakTopTimer = null;
    }
    stopPeakLoop();
    updatePeakWords(rawFromScroll());

    var top = frame.querySelector('[data-animate="body"]');
    var wait = prefersReducedMotion ? 0 : bodyDuration(top) + 0.2;
    peakTopTimer = gsap.delayedCall(wait, function () {
      peakTopTimer = null;
      if (copyShown !== 'peak') return;
      peakTopReady = true;
      peakLoop = buildPeakLoop();
      updatePeakWords(rawFromScroll());
    });
  }

  function disarmPeakWords() {
    peakTopReady = false;
    if (peakTopTimer) {
      peakTopTimer.kill();
      peakTopTimer = null;
    }
    stopPeakLoop();
    updatePeakWords(rawFromScroll());
  }

  /* Scroll no longer positions the words — it only fades the whole line out
     before the tile gallery. */
  function updatePeakWords(raw) {
    if (!peakBottom) return;
    var fade =
      1 - gsap.utils.clamp(0, 1,
        (raw - PEAK_WORDS_HIDE_FROM) / (PEAK_WORDS_HIDE_TO - PEAK_WORDS_HIDE_FROM));
    gsap.set(peakBottom, { opacity: peakTopReady ? fade : 0 });
  }

  function showCopy(key, token) {
    var frame = copies[key];
    if (!frame) return;

    if (token !== transitionToken) return;
    if (copyShown === key) return;
    copyShown = key;

    gsap.killTweensOf(frame);
    gsap.set(frame, { autoAlpha: 1, y: 0 });
    resetMarks(frame);

    if (prefersReducedMotion) {
      copyMarks(frame).forEach(function (mark) {
        mark.classList.add('in-view');
      });
      if (key === 'peak') {
        peakTopReady = true;
        updatePeakWords(rawFromScroll());
      }
      return;
    }

    if (key === 'protagonists') {
      showProtagonistsStaged(frame);
      return;
    }

    copyParts(frame).forEach(function (part, index) {
      if (typeof window.playBodyText === 'function') {
        window.playBodyText(part, partDelay(part, index));
      }
    });

    if (key === 'peak') {
      armPeakWords(frame);
    }

    frame._markTimers = copyMarks(frame).map(function (mark, index) {
      return setTimeout(function () {
        mark.classList.add('in-view');
      }, partDelay(mark, index) * 1000);
    });
  }

  function hideCopy(key, direction, token, onHidden) {
    var frame = copies[key];
    if (!frame || copyShown !== key) {
      if (onHidden) onHidden();
      return gsap.timeline();
    }
    copyShown = null;

    if (key === 'peak') disarmPeakWords();

    resetMarks(frame);
    gsap.killTweensOf(frame);

    var parts = copyParts(frame);
    var bodyTls = parts
      .map(function (part) {
        return part._bodyLineTimeline;
      })
      .filter(Boolean);

    function finish() {
      if (token === transitionToken) gsap.set(frame, { autoAlpha: 0 });
      if (onHidden) onHidden();
    }

    if (!prefersReducedMotion && bodyTls.length) {
      var duration = Math.max.apply(
        null,
        bodyTls.map(function (tl) {
          return tl.time() || 0.4;
        })
      );
      return gsap
        .timeline()
        .add(function () {
          bodyTls.forEach(function (tl) {
            tl.reverse();
          });
        })
        .to({}, { duration: duration })
        .add(finish);
    }

    return gsap.to(frame, {
      autoAlpha: 0,
      y: direction * -24,
      duration: prefersReducedMotion ? 0 : 0.35,
      ease: 'power2.in',
      overwrite: 'auto',
      onComplete: finish,
    });
  }

  /* Protagonists copy only lives at the step-2 rest pose (mask = 1). Hide it
     as soon as the 2→3 close begins, and don't bring it back on the way up
     until the circle is fully open again — otherwise lockScroll freezes the
     mask mid-transition.

     Showing is gated on `protagonistsHeldForMask` so a downward step into
     this frame still waits for the previous copy to finish hiding. Syncing
     show from every scroll tick was bringing the sequential in on top of
     the screensaver's remaining lines. */
  function syncProtagonistsForMask() {
    if (copyKey(current) !== 'protagonists') return;

    if (!protagonistsMaskOpen()) {
      if (copyShown === 'protagonists') {
        protagonistsHeldForMask = true;
        clearStaggerCalls();
        clearProtagonistsHold();
        lockScroll();
        hideCopy('protagonists', 1, transitionToken, unlockScroll);
      }
      return;
    }

    if (protagonistsHeldForMask && copyShown !== 'protagonists') {
      showCopy('protagonists', transitionToken);
      protagonistsHeldForMask = false;
    }
  }

  function hideTitle() {
    if (!title) return gsap.timeline();
    return gsap.to(title, {
      autoAlpha: 0,
      y: -16,
      duration: prefersReducedMotion ? 0 : 0.45,
      ease: 'power2.out',
      overwrite: 'auto',
    });
  }

  function showTitle() {
    if (!title) return gsap.timeline();
    return gsap.to(title, {
      autoAlpha: 1,
      y: 0,
      duration: prefersReducedMotion ? 0 : 0.55,
      ease: 'power2.out',
      overwrite: 'auto',
    });
  }

  function hideFloat() {
    if (!floatEl) return gsap.timeline();
    return gsap.to(floatEl, {
      autoAlpha: 0,
      y: -16,
      duration: prefersReducedMotion ? 0 : 0.45,
      ease: 'power2.out',
      overwrite: 'auto',
    });
  }

  function showFloat() {
    if (!floatEl) return gsap.timeline();
    return gsap.to(floatEl, {
      autoAlpha: 1,
      y: 0,
      duration: prefersReducedMotion ? 0 : 0.55,
      ease: 'power2.out',
      overwrite: 'auto',
    });
  }

  function hideTiles() {
    if (!tiles) return gsap.timeline();
    return gsap.to(tiles, {
      autoAlpha: 0,
      duration: prefersReducedMotion ? 0 : 0.4,
      ease: 'power2.out',
      overwrite: 'auto',
    });
  }

  function showTiles() {
    if (!tiles) return gsap.timeline();

    var tl = gsap.timeline();
    tl.set(tiles, { autoAlpha: 1 });

    if (!tileItems.length) return tl;

    if (prefersReducedMotion) {
      gsap.set(tileItems, { autoAlpha: 1, y: 0 });
      return tl;
    }

    gsap.set(tileItems, { autoAlpha: 0, y: 28 });
    tl.to(tileItems, {
      autoAlpha: 1,
      y: 0,
      duration: 0.65,
      stagger: 0.05,
      ease: 'power2.out',
      overwrite: 'auto',
    });

    return tl;
  }

  function setFrame(next) {
    if (next === current) return gsap.timeline();

    var myToken = ++transitionToken;

    var prev = current;
    var direction = next > prev ? 1 : -1;
    current = next;

    var prevCopy = copyKey(prev);
    var nextCopy = copyKey(next);

    /* Synchronously, before any of the timeline below is built. Skipped when
       the mask is already shut - that is the upward entry, where the copy is
       waiting on the circle to reopen and locking here would strand it. */
    if (nextCopy === 'protagonists' && prevCopy !== nextCopy &&
        protagonistsMaskOpen()) {
      holdProtagonistsEntry();
    }

    if (prevCopy === 'protagonists' && nextCopy !== prevCopy) {
      clearProtagonistsHold();
      unlockScroll();
    }

    var tl = gsap.timeline({
      onComplete: function () {
        if (myToken !== transitionToken) return;
        syncStepChange(next);
      },
    });

    if (prev === 0 && next !== 0) {
      tl.add(hideFloat());
      tl.add(hideTitle(), '-=0.25');
    }

    if (prevCopy && prevCopy !== nextCopy) {
      tl.add(hideCopy(prevCopy, direction, myToken), 0);
    }

    if (prev === maxIndex && next !== maxIndex) {
      tl.add(hideTiles(), 0);
    }

    if (next === 0) {
      tl.add(showTitle());
      tl.add(showFloat(), '-=0.3');
    }

    if (nextCopy && prevCopy !== nextCopy) {
      tl.add(function () {
        if (nextCopy === 'protagonists' && !protagonistsMaskOpen()) {
          protagonistsHeldForMask = true;
          return;
        }
        showCopy(nextCopy, myToken);
      });
    }

    if (next === maxIndex && prev !== maxIndex) {
      tl.add(showTiles(), '+=0.8');
    }

    return tl;
  }

  function onLenisScroll() {
    var index = indexFromScroll();
    if (index !== current) setFrame(index);
    syncProtagonistsForMask();
    syncProtagonistsStage();
    updatePeakWords(rawFromScroll());
  }

  function init() {
    setTrackHeight();

    if (title) {
      gsap.set(title, { autoAlpha: 1, y: 0 });
    }
    if (floatEl) {
      gsap.set(floatEl, { autoAlpha: 1, y: 0 });
    }
    if (tiles) {
      gsap.set(tiles, { autoAlpha: 0 });
    }

    prepareCopies();
    section.classList.add('is-placed');
    initSteps();
    updatePeakWords(rawFromScroll());

    var instance = lenis();
    if (instance) {
      instance.on('scroll', onLenisScroll);
    } else {
      window.addEventListener('scroll', onLenisScroll, { passive: true });
    }

    window.addEventListener('resize', function () {
      var wasPinned = isInPinnedRange();
      var progress = progressFromScroll();

      setTrackHeight();
      setStepInstant(displayedStepIndex);

      var instance = lenis();
      if (instance) instance.resize();
      if (!wasPinned) return;
      var top = scrollTopForProgress(progress);
      if (instance) instance.scrollTo(top, { immediate: true, force: true });
      else window.scrollTo(0, top);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
